import { useQuery } from "@apollo/client";
import _, { Dictionary } from "lodash";
import { useCallback, useState } from "react";
import { Article, ProductGroup } from "../../api/schema";
import { Spinner } from "../../components/Spinner";
import { useGlobalState } from "../../Context";
import { ArticleDisplay } from "./ArticleDisplay";
import { ArticleList } from "./ArticleList";
import {
  ArticleViewQuery,
  ArticleViewQueryResult,
  ProductGroupQuery,
  ProductGroupQueryResult,
} from "./graphql";
import { ProductGroupTree } from "./ProductGroupTree";

export const ArticleListViewController = (props: {}) => {
  const { global_state } = useGlobalState();
  const [group_repository, set_group_repsitory] = useState<
    Dictionary<ProductGroup>
  >({});

  const [loading, set_loading] = useState(true);
  const [active_product_group, set_active_producct_group] =
    useState<ProductGroup | null>(null);
  const [active_article, set_active_article] = useState<Article | null>(null);

  const product_group_query = useQuery<ProductGroupQueryResult, { id: number }>(
    ProductGroupQuery,
    {
      skip: true,
      fetchPolicy: "no-cache",
      onCompleted: (data: ProductGroupQueryResult) =>
        set_group_repsitory(
          _.set(group_repository, data.productGroup.id, data.productGroup)
        ),
    }
  );

  const update_product_groups = useCallback(
    (pgs: ProductGroup[]) => {
      const gr = _.cloneDeep(group_repository);
      _.forEach(pgs, (p) => _.set(gr, p.id, p));
      set_group_repsitory(gr);
    },
    [group_repository]
  );

  const fetch = useCallback(
    (id: number) =>
      product_group_query
        .refetch({ id: id })
        .then((data) => data.data.productGroup),
    [product_group_query]
  );

  useQuery<ArticleViewQueryResult>(ArticleViewQuery, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      set_loading(false);
      set_group_repsitory(
        _.transform(
          data.productGroups,
          (obj, pg) => {
            _.set(obj, pg.id, pg);
          },
          {}
        )
      );
    },
  });

  if (loading) return <Spinner />;

  let classes = ["article_list"];
  if (global_state.dark_mode) classes.push("container-dark");

  return (
    <div className={classes.reverse().join(" ")}>
      <div style={{ width: 300, borderRight: "2px solid gray" }}>
        <ProductGroupTree
          fetch_product_group={fetch}
          group_repository={group_repository}
          set_active_product_group={(g) => {
            set_active_article(null);
            set_active_producct_group(g);
          }}
          update_product_groups={update_product_groups}
          key={"pgt"}
        />
      </div>
      <div style={{ flex: 2 }}>
        <ArticleList
          active_article={active_article}
          set_article={set_active_article}
          product_group={active_product_group}
        />
      </div>
      <div style={{ flex: 1, borderLeft: "2px solid gray" }}>
        <ArticleDisplay article={active_article} />
      </div>
    </div>
  );
};
